export const EmptyNextSchedules = () => {
  return (
    <div>
      <div className="my-8 mx-2">
        Próximas revisões
      </div>

      <div className="border rounded-lg w-full">
        <div className="text-size-14 text-color-dark border-color-light border-b">
          <div className="p-4">Dados insuficientes</div>
        </div>
        <div className="p-4 text-size-14 text-color-dark">
            <div className="mb-4">Não foi possível exibir as próximas revisões deste veículo</div>
            <div className="mb-4">Para gerar as previsões, é necessário que as seguintes informações estejam disponíveis:</div>
            <ul className="mb-4 pl-8">
                <li className="list-disc">Chassi do veículo</li>
                <li className="list-disc">Grupo de manutenção</li>
                <li className="list-disc">Odômetro atual</li>
            </ul>
            <div className="mb-4">Por favor, verifique se os dados estão cadastrados corretamente no sistema.</div>
        </div>

        <div className="flex justify-center items-center p-4">
          <span className="rioglyph rioglyph-cloud-not-saved text-color-lighter" style={{ fontSize: '100px' }} />
        </div>
      </div>
    </div>
  );
};